module.exports = __webpack_public_path__ + "img/collection-ja.1e7a688b.png";